import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { ModalGeneric } from "components/modal/ModalGeneric";
import Pagination from "components/Pagination/Pagination";
import { SearchAdvancedModule } from "components/SearchSimpleAdvanced/SearchAdvancedModule";
import TableOrder from "components/Tables/TableOrder";
import { useModal } from "hooks/useModal";
import { ExportDetail } from "pages/CustomsClearance/Adjunto/ExportDetail";
import { HeaderSearch } from "styled/SectionContainer.styled";
import { Title } from "styled/Title";
import {
  arrayLeftTreasury,
  arrayRigthTreasury,
  arrayRigthUserTreasury,
  salesOfServiceNodeInputFields,
  TitleSales
} from "../ArrayList/ArrayList";
import FormSearch from "../Forms/FormSearch";
import { useForm } from "hooks/useForm";
import TbodySalesOfService from "../Tables/TbodySalesOfService";
import Buttons from "../Buttons/Buttons";
import FormRecharge from "../Forms/FormRecharge";
import FormPayOnLine from "../Forms/FormPayOnLine";
import { useSelector } from "react-redux";
import environment from "constants/apiConst";
import TreasuryCrudContex from "context/TreasuryContex";
import { AuthContext } from "context/AuthContext";
import IncidentsView from "./IncidentsView";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { __Post } from "request/Petitions/__Post";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";
import queryEnv from "constants/queryConst";
import RechargesTaxesTable from "./RechargesTaxesTable";
import { useDispatch } from "react-redux";
import { clearSearch, setSearch } from "redux/actions/searchActions";
import { ModalExportAdvance } from "components/ExportByColumn/ExportAdvance";
import { isArray } from "utils/type-check-utils";
import { useSearchUrl } from "hooks/useSearchUrl";
import { useRecharges, useRechargesSearch } from "hooks/useRecharges";

const SalesOfService = () => {
  const { state, clearParamsSearch } = useSearchUrl({ getParams: ["search", "valueQualified"], nestedProp: "searchSimple" });
  const { cleanState } = useSearchUrl({ getParams: ["invoice", "date1", "date2", "type", "payment_method", "valueMethod", "valueDocument"], nestedProp: "searchAdvance" });

  const [page, setPage] = useState(1);
  const [pageSearch, setPageSearch] = useState(1);
  const [isOpenSearch, onOpenSearch, onCloseSearch] = useModal();
  const [isOpenExport, onOpenExport, onCloseExport] = useModal();
  const [changeViewSearch, setChangeViewSearch] = useState(false);
  const [searcheAdvanced, setSearchAdvanced] = useState(cleanState);
  const [isOpenPercentage, onOpenPercentage, onClosePercentage] = useModal();
  const [isOpenPay, onOpenPay, onClosePay] = useModal();
  const [openAlert] = AlertErrorAlert();
  const { authUser } = useContext(AuthContext);
  const [allAccess, setAllAccess] = useState(false);
  const { user_rol, admin } = useSelector((state) => state.auth.dataUser);
  const [myPermission, setmyPermission] = useState(null);

  const token = useSelector((state) => state.auth.dataUser.token);
  const {
    isOpenRecharge,
    onOpenRecharge,
    onCloseModal,
    isOpenIncidents,
    dataToIncidents
  } = useContext(TreasuryCrudContex);

  const [values, handleInputChange, reset, setValues] = useForm({
    searchInformacion: state?.search || "",
    valueQualified: state?.valueQualified || [],
  });

  const { searchInformacion, valueQualified } = values;

  // React Query hooks
  const { data: rechargesData, isLoading } = useRecharges(token, page, !changeViewSearch);
  
  // Preparar datos de búsqueda con useMemo para estabilizar
  const searchData = useMemo(() => ({
    ...(valueQualified && valueQualified?.value && {
      qualifiedUser_id: valueQualified?.value
    }),
    ...(searchInformacion && { search: searchInformacion }),
    ...searcheAdvanced
  }), [valueQualified, searchInformacion, searcheAdvanced]);
  
  // Hook de búsqueda con useQuery
  const { 
    data: searchData_result, 
    isLoading: isSearchLoading, 
    error: searchError
  } = useRechargesSearch(token, searchData, pageSearch, changeViewSearch && Object.keys(searchData).length > 0);
  
  // Ref para funciones de dispatch estables
  const dispatchSearchRef = useRef();
  const dispatchClearSearchRef = useRef();
  const lastSearchDataRef = useRef(null);
  const shouldResetPageRef = useRef(false);
  const lastQualifiedUserIdRef = useRef(null);

  const backSearch = () => {
    clearParamsSearch({ searchArray: ["searchAdvance", "searchSimple"] });
    reset();
    setSearchAdvanced({});
    setChangeViewSearch(false);
  };

  const dispatchRedux = useDispatch();
  
  // Configurar funciones de dispatch en refs para evitar bucles
  dispatchSearchRef.current = (data) => {
    dispatchRedux(setSearch(data));
  };
  
  dispatchClearSearchRef.current = () => {
    dispatchRedux(clearSearch());
  };

  // useEffect simplificado para manejar cambios de búsqueda
  useEffect(() => {
    const searchDataString = JSON.stringify(searchData);
    const lastSearchDataString = lastSearchDataRef.current ? JSON.stringify(lastSearchDataRef.current) : null;
    
    // Solo ejecutar si los datos realmente han cambiado
    if (searchDataString !== lastSearchDataString) {
      lastSearchDataRef.current = searchData;
      
      // Si hay datos de búsqueda, activar modo búsqueda
      if (Object.keys(searchData).length > 0) {
        setChangeViewSearch(true);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchSearchRef.current(searchData);
        onCloseSearch();
      } else {
        // Si no hay datos de búsqueda, limpiar modo búsqueda
        setChangeViewSearch(false);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchClearSearchRef.current();
      }
    }
  }, [searchData, onCloseSearch]);

  // useEffect para resetear página cuando cambien los parámetros de búsqueda
  useEffect(() => {
    if (shouldResetPageRef.current && changeViewSearch) {
      setPageSearch(1);
      shouldResetPageRef.current = false;
    }
  }, [changeViewSearch]);

  // useEffect específico para detectar cambios en usuario calificado
  useEffect(() => {
    const currentQualifiedUserId = valueQualified?.value || null;
    const lastQualifiedUserId = lastQualifiedUserIdRef.current;
    
    // Si el usuario calificado ha cambiado y estamos en modo búsqueda, resetear página
    if (currentQualifiedUserId !== lastQualifiedUserId && changeViewSearch) {
      setPageSearch(1);
    }
    
    // Actualizar el ref con el valor actual
    lastQualifiedUserIdRef.current = currentQualifiedUserId;
  }, [valueQualified, changeViewSearch]);

  // useEffect para manejar errores de búsqueda
  useEffect(() => {
    if (searchError) {
      if (searchError.message === "Acceso no autorizado.") {
        reset();
        setSearchAdvanced({});
        setChangeViewSearch(false);
        openAlert(searchError.message, "error");
      } else {
        console.error('Error en búsqueda:', searchError);
      }
    }
  }, [searchError, reset, openAlert]);

  // useEffect para limpiar búsqueda al desmontar
  useEffect(() => {
    return () => dispatchClearSearchRef.current();
  }, []);

  const handleSubmit = async (data, formulario) => {
    try {
      const info = {
        fields: formulario,
        data: {
          ...data,
          ...(isArray(data?.type_export_file) &&
            data?.type_export_file?.length !== 0 && {
            type_export_file: data?.type_export_file?.value
          }),
        },
      };
      const res = await __Post(environment.TREASURY_RECHARGE_EXPORT, token, info);
      console.log(res);
      if (res?.data?.status?.code === 200) {
        onCloseExport();
        return openAlert(`${res?.data?.status?.message}`, "success");
      } else {
        // console.log(res);
        return openAlert(`${res?.data?.status?.message}`, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (admin === 1) {
      setAllAccess(true);
    } else if (!allAccess) {
      const newArray = [];
      user_rol?.modules?.map((item) => {
        return item.permission.map((e) => newArray.push(e.name_permission));
      });
      setmyPermission(newArray);
    }
  }, [user_rol, allAccess, admin]);

  const { requestData } = useGlobalContext();
  useQuery({
    queryKey: [queryEnv?.TAXES_RECHARGES],
    queryFn: () => requestData({ Endpoint: environment.TREASURY_RECHARGES_TAXES, PropertyBody: "POST" }),
  })

  const calculateNodeList = {
    1: arrayLeftTreasury.concat(arrayRigthUserTreasury),
    0: arrayLeftTreasury.concat(arrayRigthTreasury),
  }[authUser.is_qualified_user]

  return (
    <>
      <ModalGeneric
        isOpen={isOpenIncidents}
        onClose={onCloseModal}
        title={`Factura Nº ${dataToIncidents?.invoice}`}
        size={"6xl"}
      >
        <IncidentsView onClose={onCloseModal} />
      </ModalGeneric>

      <ModalGeneric
        isOpen={isOpenRecharge}
        onClose={onCloseModal}
        title={"Venta de recargas"}
        size={"xl"}
        scrollBehavior={"outside"}
      >
        <FormRecharge onClose={onCloseModal} onOpenRecharge={onOpenRecharge} />
      </ModalGeneric>

      <ModalGeneric
        isOpen={isOpenPercentage}
        onClose={onClosePercentage}
        title={"Manejo del IVA"}
        size={"3xl"}
      >
        <RechargesTaxesTable />
      </ModalGeneric>
      <ModalGeneric
        isOpen={isOpenPay}
        onClose={onClosePay}
        title={"Pago en Linea"}
        size={"xl"}
      >
        <FormPayOnLine onclose={onClosePay} />
      </ModalGeneric>

      <Title style={{ marginTop: 30 }}>Ventas de servicios</Title>
      <ModalGeneric
        isOpen={isOpenSearch}
        onClose={onCloseSearch}
        title={"Búsqueda avanzada"}
      >
        <FormSearch
          onClose={onCloseSearch}
          setSearchAdvanced={setSearchAdvanced}
        />
      </ModalGeneric>

      <ModalExportAdvance
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title="Exportar documentos"
        handleSubmit={handleSubmit}
        nodeList={calculateNodeList}
        selectNodeList={salesOfServiceNodeInputFields}
        enableAdvance={true}
      />

      {/*    <ModalGeneric
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title={"Exportar documento"}
      // size={"4xl"}
      >
        <ExporByColumn
          onClose={onCloseExport}
          ListLeft={arrayLeftTreasury}
          listRight={
            authUser.is_qualified_user === 1
              ? arrayRigthUserTreasury
              : arrayRigthTreasury
          }
          dafaulActive={[]}
          handleSubmit={handleSubmit}
        />
      </ModalGeneric> */}
      <div className="container p-4">
        <SearchAdvancedModule
          handleInputChange={handleInputChange}
          values={values}
          onOpenSearch={onOpenSearch}
          changeViewSearch={changeViewSearch}
          backSearch={backSearch}
          permisoSearch={"getRecharges"}
          allAccess={allAccess}
          myPermission={myPermission}
          setValues={setValues}
        />
        <ExportDetail onOpen={onOpenExport} />
      </div>

      <HeaderSearch>
        <Buttons
          onOpenRecharge={onOpenRecharge}
          onOpenPercentage={onOpenPercentage}
          onOpenPay={onOpenPay}
        />

        {changeViewSearch
          ? (
            <div className="px-5">
              <div>
                <TableOrder
                  thead={TitleSales}
                  data={searchData_result?.data || []}
                  setData={() => {}} // React Query maneja los datos
                  loading={isSearchLoading}
                  tbodyData={TbodySalesOfService}
                />

                <Pagination
                  page={pageSearch}
                  setPage={setPageSearch}
                  maxPage={searchData_result?.lastPage || 1}
                  loading={isSearchLoading}
                />
              </div>
            </div>
          )
          : (
            <div>
              <TableOrder
                thead={TitleSales}
                data={rechargesData?.data || []}
                setData={() => {}} // React Query maneja los datos
                loading={isLoading}
                tbodyData={TbodySalesOfService}
              />
              <Pagination
                page={page}
                setPage={setPage}
                maxPage={rechargesData?.lastPage || 1}
                loading={isLoading}
              />
            </div>
          )}
      </HeaderSearch>
    </>
  );
};

export default SalesOfService;
